import { State } from "store/state";

export const selectMetadata = (state: State) => state.metadata;
